import React from 'react';
import PropTypes from 'prop-types';
import {
    RSVPTel,
    RSVPLink
} from '../events_common';
import LazyImg from '../lazy_img/index.jsx';
import { getLocationObject, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';

const EventDetails = (props) => {
    const {
        title,
        startDateTime,
        endDateTime,
        locationVenueName,
        locationAddress,
        description,
        image,
        disclosure,
        rsvpType,
        rsvpLink,
        rsvpInfo,
        shouldDisplayOtherEventsCTA,
        otherEventsLinkUrl,
        labelRsvp,
        labelRsvpButtonText
    } = props;

    const locationObject = getLocationObject(locationAddress);

    return (
        <div className="event-details">
            <h1 className="event-details__title">{title}</h1>
            <div className="event-details__main-wrapper">
                <div className="event-details__container">
                    <div className="event-details__content-wrapper">
                        <h2 className="event-details__subtitle">{title}</h2>
                        <div className="event-details__dates">
                            <div className="event-details__start-date">{startDateTime}</div>
                            <div className="event-details__end-date">{endDateTime}</div>
                        </div>
                        <div className="event-details__location-address">
                            {
                                !locationObject.isVirtual ?
                                    <a href={locationObject.gMapsUrl}
                                        target="_blank"
                                    >
                                        {locationObject.address}
                                    </a> :
                                    <span>
                                        {locationObject.address}
                                    </span>
                            }
                        </div>
                        <div className="event-details__location-venue-name">{locationVenueName}</div>
                        {rsvpType && (
                            rsvpType === "phone"
                                ?
                                <RSVPTel
                                    className="event_details__rsvp-tel"
                                    text={rsvpInfo}
                                    link={rsvpLink}
                                    labelRsvp={labelRsvp}
                                    eventName={title}
                                />
                                :
                                <RSVPLink
                                    className="event_details__rsvp-link"
                                    link={rsvpLink}
                                    linkType={rsvpType}
                                    labelRsvpButton={labelRsvpButtonText}
                                    eventName={title}
                                />
                        )}
                        <div
                            className="event-details__description"
                            dangerouslySetInnerHTML={{ __html: RA_73_STERILIZE_HTML_STRING(description) }}
                        />
                        <div className="event-details__disclosure">{disclosure}</div>
                    </div>
                    <div className="event-details__image-wrapper">
                        <LazyImg className="event-details__image" src={image} alt="Event"/>
                    </div>
                </div>
            </div>
            <div className="event-details__other-events-link-wrapper">
                {shouldDisplayOtherEventsCTA &&
                    <a className="event-details__other-events-link" href={otherEventsLinkUrl}>Other events</a>
                }
            </div>
        </div>
    );
};

EventDetails.propTypes = {
    title: PropTypes.string.isRequired,
    startDateTime: PropTypes.string.isRequired,
    endDateTime: PropTypes.string,
    locationVenueName: PropTypes.string,
    locationAddress: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string,
    disclosure: PropTypes.string,
    rsvpType: PropTypes.string,
    rsvpLink: PropTypes.string,
    rsvpInfo: PropTypes.string,
    shouldDisplayOtherEventsCTA: PropTypes.bool,
    otherEventsLinkUrl: PropTypes.string,
    labelRsvp: PropTypes.string,
    labelRsvpButtonText: PropTypes.string,
    sectionId: PropTypes.string
};

export default EventDetails;



// WEBPACK FOOTER //
// ./components/event_details/index.jsx